import { MARKET } from "./marketplaceRoutes";

/** Maps product category display names to canonical route paths */
export const CATEGORY_ROUTE_MAP = {
  "Super Market": MARKET.CATEGORY_SUPERMARKET,
  Supermarket: MARKET.CATEGORY_SUPERMARKET,
  "Health & Beauty": MARKET.CATEGORY_HEALTH_BEAUTY,
  "Home & Office": MARKET.CATEGORY_HOME_OFFICE,
  Appliances: MARKET.CATEGORY_APPLIANCES,
  Appliance: MARKET.CATEGORY_APPLIANCES,
  "Phones & Tablets": MARKET.CATEGORY_PHONES_TABLETS,
  Computing: MARKET.CATEGORY_COMPUTING,
  Electronics: MARKET.CATEGORY_ELECTRONICS,
  Fashion: MARKET.CATEGORY_FASHION,
  "Baby Products": MARKET.CATEGORY_BABY_KIDS,
  "Baby, kids & Toy": MARKET.CATEGORY_BABY_KIDS,
  Gaming: MARKET.CATEGORY_GAMING,
  "Sporting Goods": MARKET.CATEGORY_SPORTING,
  "Drink & Groceries": MARKET.CATEGORY_GROCERY,
  Grocery: MARKET.CATEGORY_GROCERY,
  "Kitchen Utensils": MARKET.CATEGORY_KITCHEN,
  "Building Materials": MARKET.CATEGORY_BUILDING,
  "Building Material": MARKET.CATEGORY_BUILDING,
};

export const getCategoryPath = (categoryName) => {
  if (!categoryName) return MARKET.HOME;
  return CATEGORY_ROUTE_MAP[categoryName] || MARKET.HOME;
};

export const NIGERIAN_STATES = [
  "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue",
  "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT",
  "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi",
  "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo",
  "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
];

/** Route path -> listing page config for shared ProductListingPage */
export const LISTING_PAGE_CONFIG = {
  [MARKET.CATEGORY_SUPERMARKET]: { apiPath: "category/supermarket", title: "SUPER MARKET", breadcrumb: "Super Market", queryKey: "supermarketProducts", productsKey: "products" },
  [MARKET.CATEGORY_HEALTH_BEAUTY]: { apiPath: "category/health/beauty", title: "HEALTH & BEAUTY", breadcrumb: "Health & Beauty", queryKey: "healthBeautyProducts", productsKey: "products" },
  [MARKET.CATEGORY_HOME_OFFICE]: { apiPath: "category/home/office", title: "HOME & OFFICE", breadcrumb: "Home & Office", queryKey: "homeOfficeProducts", productsKey: "products" },
  [MARKET.CATEGORY_APPLIANCES]: { apiPath: "category/appliance", title: "APPLIANCES", breadcrumb: "Appliances", queryKey: "applianceProducts", productsKey: "products" },
  [MARKET.CATEGORY_PHONES_TABLETS]: { apiPath: "category/tablets/phones", title: "PHONES & TABLETS", breadcrumb: "Phones & Tablets", queryKey: "phoneTabletProducts", productsKey: "products" },
  [MARKET.CATEGORY_COMPUTING]: { apiPath: "category/computing", title: "COMPUTING", breadcrumb: "Computing", queryKey: "computingProducts", productsKey: "products" },
  [MARKET.CATEGORY_ELECTRONICS]: { apiPath: "category/electronics", title: "ELECTRONICS", breadcrumb: "Electronics", queryKey: "electronicsProducts", productsKey: "products" },
  [MARKET.CATEGORY_FASHION]: { apiPath: "category/fashion", title: "FASHIONS", breadcrumb: "Fashions", queryKey: "fashionProducts", productsKey: "products" },
  [MARKET.CATEGORY_BABY_KIDS]: { apiPath: "category/baby/toy", title: "BABY PRODUCTS", breadcrumb: "Baby Products", queryKey: "babyToyProducts", productsKey: "products" },
  [MARKET.CATEGORY_GAMING]: { apiPath: "category/gaming", title: "GAMING", breadcrumb: "Gaming", queryKey: "gamingProducts", productsKey: "products" },
  [MARKET.CATEGORY_SPORTING]: { apiPath: "category/sporting/goods", title: "SPORTING GOODS", breadcrumb: "Sporting Goods", queryKey: "sportingProducts", productsKey: "products" },
  [MARKET.CATEGORY_GROCERY]: { apiPath: "category/grocery", title: "DRINK & GROCERIES", breadcrumb: "Drink & Groceries", queryKey: "groceryProducts", productsKey: "products" },
  [MARKET.CATEGORY_KITCHEN]: { apiPath: "category/kitchen/utenssils", title: "KITCHEN UTENSILS", breadcrumb: "Kitchen Utensils", queryKey: "kitchenProducts", productsKey: "products" },
  [MARKET.CATEGORY_BUILDING]: { apiPath: "category/building/material", title: "BUILDING MATERIALS", breadcrumb: "Building Materials", queryKey: "buildingProducts", productsKey: "products" },
  [MARKET.DEALS_RECOMMENDED]: { apiPath: "all-products", title: "RECOMMENDED PRODUCTS", breadcrumb: "Recommended", queryKey: "recommendedProducts", productsKey: "products" },
  [MARKET.DEALS_TRENDING]: { apiPath: "category/trending-deals", title: "TRENDING DEALS", breadcrumb: "Trending", queryKey: "trendingDeals", productsKey: "trendingProducts" },
  [MARKET.DEALS_TODAY]: { apiPath: "category/todays-deals", title: "TODAY'S DEALS", breadcrumb: "Today's Deals", queryKey: "todaysDeal", productsKey: "todaysDealProducts" },
  [MARKET.DEALS_TOP_SELLING]: { apiPath: "category/hot-deals", title: "TOP SELLING", breadcrumb: "Top Selling", queryKey: "topselling", productsKey: "hotDealProducts" },
};

export const getListingConfig = (pathname) => LISTING_PAGE_CONFIG[pathname] || null;
